import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface TooltipProps {
    children: React.ReactNode;
    tooltipText: string;
}

export const Tooltip: React.FC<TooltipProps> = ({ children, tooltipText }) => {
    const [visible, setVisible] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const triggerRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (!visible || !triggerRef.current) return;

        const rect = triggerRef.current.getBoundingClientRect();
        setCoords({
            top: rect.top - 10,
            left: rect.left + rect.width / 2,
        });
    }, [visible]);

    // Portal tooltip element
    const portalTooltip = visible ? (
        <div
            style={{
                position: 'fixed',
                top: coords.top,
                left: coords.left,
                transform: 'translate(-50%, -100%)',
                zIndex: 999999,
                padding: '8px 12px',
                backgroundColor: '#333',
                color: 'white',
                borderRadius: 6,
                whiteSpace: 'pre-line',
                minWidth: '200px',
                textAlign: 'left',
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.15s ease',
                pointerEvents: 'none',
                boxShadow: '0px 4px 12px rgba(0,0,0,0.25)',
            }}
        >
            {tooltipText}
        </div>
    ) : null;

    return (
        <>
            {/* Trigger element */}
            <span
                ref={triggerRef}
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                {children}
            </span>

            {/* Tooltip rendered outside the DOM tree */}
            {ReactDOM.createPortal(portalTooltip, document.body)}
        </>
    );
};
